const initialState = {
  closeTabTargetAM: false,
  listAreaManager: [],
  statusInputTargetAM: true,
  statusInputTargetAMProduktif: true,
  listTargetAreaManager: [],
  listTargetAreaManagerProduktif: [],
};

const areaManagerReducer = (state = initialState, action) => {
  let { type, data } = action;
  switch (type) {
    case "SET_CLOSE_TAB_TARGET_AREAMANAGER":
      return {
        ...state,
        closeTabTargetAM: data,
      };
    case "SET_ALLAREAMANAGER":
      return {
        ...state,
        listAreaManager: data,
      };
    case "SET_STATUS_INPUT_TARGET_AREAMANAGER":
      return {
        ...state,
        statusInputTargetAM: data,
      };
    case "SET_ALL_TARGET_AREAMANAGER":
      return {
        ...state,
        listTargetAreaManager: data,
      };
    case "SET_ALL_TARGET_AREAMANAGER_PRODUKTIF":
      return {
        ...state,
        listTargetAreaManagerProduktif: data,
      };
    case "SET_STATUS_INPUT_TARGET_AREAMANAGER_PRODUKTIF":
      return {
        ...state,
        statusInputTargetAMProduktif: data,
      };
    default:
      return state;
  }
};
export default areaManagerReducer;
